"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.createAuthentication = createAuthentication;
var _AuthContext = require("./AuthContext");
var _AuthProvider = require("./AuthProvider/AuthProvider");
var _useAuth = require("./useAuth");
function createAuthentication(authImplementation, customProviderHooks) {
  const AuthContext = (0, _AuthContext.createAuthContext)();
  const useAuth = (0, _useAuth.createUseAuth)(AuthContext);
  const AuthProvider = (0, _AuthProvider.createAuthProvider)(AuthContext, authImplementation, customProviderHooks);
  return {
    AuthContext,
    AuthProvider,
    useAuth
  };
}